import axios from "axios";

import { OptimizationRule } from "../types/optimization-rule";

export interface CreateOptimizationRuleData {
  name: string;
  description: string;
  target: string;
  period?: number;
  "bidding-strategy"?: string;
  "custom-value-cutoff"?: number | null;
  "custom-cpa-cutoff"?: number | null;
  "custom-fop-weight"?: number | null;
  "custom-cltv-weight"?: number | null;
  "custom-cltp-weight"?: number | null;
  "custom-cp-weight"?: number | null;
  "max-value"?: number | null;
  "min-value-%ile"?: number | null;
  "max-value-%ile"?: number | null;
  "avg-order-value"?: number | null;
}

export const createOptimizationRule = async (
  workspaceSlug: string,
  data: CreateOptimizationRuleData,
): Promise<OptimizationRule> => {
  return (
    await axios.post(
      `/api/v1/workspaces/${workspaceSlug}/optimization-rules`,
      data,
    )
  ).data;
};

export const getOptimizationRules = async (
  workspaceSlug: string,
): Promise<{ total: number; rules: OptimizationRule[] }> => {
  return (
    await axios.get(`/api/v1/workspaces/${workspaceSlug}/optimization-rules`)
  ).data;
};

export const getOptimizationRule = async (
  workspaceSlug: string,
  id: number,
): Promise<OptimizationRule> => {
  return (
    await axios.get(
      `/api/v1/workspaces/${workspaceSlug}/optimization-rules/${id}`,
    )
  ).data;
};

export const deleteOptimizationRule = async (
  workspaceSlug: string,
  id: number,
): Promise<void> => {
  await axios.delete(
    `/api/v1/workspaces/${workspaceSlug}/optimization-rules/${id}`,
  );
};
